<template>
  <div>
    <title-row
      title="Időszakok"
      :subtitle="
        dataTable.itemsLength === -1
          ? 'Betöltés...'
          : `${dataTable.itemsLength} időszak van a rendszerben`
      "
      :breadcrumb-items="[
        {
          text: 'Időszakok',
          disabled: true,
        },
      ]"
    >
      <template #buttons>
        <title-row-button
          v-if="hasRight('SCHEDULE_WRITE')"
          :to="{ name: 'NewDateInterval' }"
          title="Hozzáadás"
        >
          <v-icon left>mdi-plus</v-icon>
          Új időszak
        </title-row-button>
        <!-- <title-row-button v-on:click="fetchPublicHolidays" title="Munkaszüneti napok frissítése">
          Munkaszüneti napok frissítése
        </title-row-button>
        <title-row-button v-on:click="testCronDateUpdate" title="cron napok frissítése">
          cron teszt frissítése
        </title-row-button> -->
      </template>
    </title-row>

    <v-expansion-panels
      class="mb-4 rounded-xl overflow-hidden"
      :mandatory="!!Object.values(search).find((e) => e !== '')"
      flat
    >
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="font-weight-medium">
            <v-icon left>mdi-magnify</v-icon>
            Keresés
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="mt-2">
            <v-col :cols="12" :sm="4" :md="3">
              <v-text-field
                v-model="search.name"
                @input="searchEventHandler"
                label="Megnevezés"
                clearable
                hide-details
                filled
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-card class="rounded-xl" flat>
      <v-data-table
        :loading="loading"
        :headers="dataTable.headers"
        :items="dataTable.items"
        :server-items-length="dataTable.itemsLength"
        :options.sync="dataTable.options"
        :footer-props="$config.dataTableFooterProps"
      >
        <template #[`item.d`]="{ item }"
          >{{ item.start_date | moment('ll') }} - {{ item.end_date | moment('ll') }}</template
        >
        <template #[`item.is_recurring`]="{ item }">
          <v-icon :color="item.is_recurring ? 'success' : 'error'">
            {{ item.is_recurring ? 'mdi-check' : 'mdi-close' }}
          </v-icon>
        </template>
        <template #[`item.actions`]="{ item }">
          <v-btn
            v-if="hasRight('SCHEDULE_WRITE')"
            text
            fab
            small
            dark
            color="primary"
            class="rounded-sm ma-1"
            :to="{ name: 'DateIntervalEditor', params: { id: item.id } }"
            title="Szerkesztés"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            v-if="hasRight('SCHEDULE_WRITE')"
            text
            fab
            small
            dark
            color="primary"
            class="rounded-sm ma-1"
            @click="deleteDateInterval(item)"
            title="Törlés"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import { dataTablePage } from '@/mixins';

export default {
  mixins: [dataTablePage],

  data() {
    return {
      routeName: 'DateIntervalList',
      fetchItems: this.fetchDateIntervals,
      dataTable: {
        options: {
          sortBy: ['name'],
        },
        headers: [
          { text: 'Megnevezés', value: 'name' },
          { text: 'Időszak', value: 'd', sortable: false },
          // évenként megismétlődik az időszak, mozgó ünnepek megoldása még
          { text: 'Évente ismétlődő', value: 'is_recurring', sortable: false },
          { text: '', value: 'actions', sortable: false, align: 'end' },
        ],
      },
      search: {
        name: '',
      },
      searchTimeout: null,
    };
  },

  mounted() {
    this.testCronDateUpdate();
  },

  methods: {
    parseSearchQueries() {
      return {
        license_plate_number: this.$route.query.license_plate_number,
        rf_id_code: this.$route.query.rf_id_code,
      };
    },

    async deleteDateInterval(item) {
      const confirm = await this.$dialog.confirm({
        type: 'error',
        text: `<b>${item.name}</b> időszak törlésére készül! Folytatja?`,
        title: 'Figyelem',
      });

      if (confirm) {
        try {
          await this.$http.get('date-intervals/delete/' + item.id);
          this.fetchDateIntervals();
          this.$dialog.notify.info('Az időszak törölve!');
        } catch (e) {
          console.error(e);
        }
      }
    },

    async fetchDateIntervals() {
      this.loading = true;
      try {
        const data = JSON.parse(JSON.stringify(this.search));
        data.sort_by = this.options.sortBy || [''];
        data.sort_desc = this.options.sortDesc || [false];
        const response = await this.$http.post('date-intervals/list', this.options);
        this.dataTable.items = response.date_intervals;
        this.dataTable.itemsLength = response.date_intervals_count;
        this.dataTable.options.page = Number(this.$route.query.page) || 1;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    async fetchPublicHolidays() {
      try {
        await this.$http.get('date-intervals/update-holidays');
        this.fetchDateIntervals();
        this.$dialog.notify.info('Munkaszüneti napok betöltve!');
      } catch (e) {
        console.error(e);
      }
    },

    async testCronDateUpdate() {
      try {
        await this.$http.get('date-intervals/test-cron');
        this.fetchDateIntervals();

        timeout = setTimeout(() => {
          this.testCronDateUpdate();
        }, 24 * 60 * 60 * 1000);

        fetchDateIntervals();
      } catch (e) {
        console.error(e);
      }
    },
  },

  computed: {
    searchQueries() {
      return {
        name: this.search.name || '',
      };
    },
  },
};
</script>
